import { AfterViewInit, Component, computed, effect, OnInit, signal } from '@angular/core';
import { NavigationStart, Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './core/components/header/header.component';
import { FooterComponent } from './core/components/footer/footer.component';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs';
import config from '../assets/config.json';
import { EmulationDisplayerComponent } from './core/components/emulation-displayer/emulation-displayer.component';
import { EmulationService } from './shared/services/emulation.service';
import { switchAdvisorService } from './shared/services/switchAdvisorService';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent, CommonModule, EmulationDisplayerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'FinPro';
  emulatedUser = computed(() => this._emulationService.emulatedUser());
  headerVisible = signal(true); // Signal to control visibility
  constructor(
    private _router: Router,
    private _emulationService: EmulationService,
    private _switchAdvisorService: switchAdvisorService,
  ) {
    const nav = window.performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
    // Subscribe to router events
    this._router.events
      .pipe(
        filter((event) => event instanceof NavigationStart), // Listen for route change event
      )
      .subscribe(() => {
        // Scroll to the top on route change
        window.scrollTo(0, 0);
      });
    effect(
      () => {
        if (this._emulationService.emulatedUser() && nav?.type !== 'reload') {
          // Read the signal
          this.refreshHeader(); // Trigger when `emulatedUser` changes
        }
      },
      { allowSignalWrites: true },
    );
  }

  ngOnInit(): void {
    this.loadOneTrustScripts();
    this._emulationService.refreshHeader.subscribe((_myCustomParam) => {
      // call your method whenever its triggered.
      this.refreshHeader();
    });
  }
  ngAfterViewInit(): void {
    this.updateDynamicStyles('#onetrust-consent-sdk #onetrust-pc-sdk .ot-label-status{font-size:12px !important; }');
  }

  loadOneTrustScripts() {
    const oneTrustConfig = { ...config };
    const oneTrustScripts = [oneTrustConfig.OneTrust_CDN, oneTrustConfig.OneTrust_CDN_Cookie];
    oneTrustScripts.forEach((scriptUrl) => {
      const script = document.createElement('script');
      script.src = scriptUrl;
      script.async = true;
      script.type = 'text/javascript';
      if (scriptUrl === oneTrustConfig.OneTrust_CDN_Cookie) {
        script.setAttribute('data-document-language', oneTrustConfig.dataDocumentLanguage as string);
        script.setAttribute('data-domain-script', oneTrustConfig.dataDomainScript as string);
      }
      document.head.appendChild(script);
    });
  }
  updateDynamicStyles(css: string) {
    const styleTag = document.getElementById('onetrust-style') as HTMLStyleElement;

    if (styleTag) {
      styleTag.innerHTML = css;
    } else {
      const newStyle = document.createElement('style');
      newStyle.id = 'onetrust-style1';
      newStyle.innerHTML = css;
      document.head.appendChild(newStyle);
    }
  }
  refreshHeader() {
    this.headerVisible.set(false);
    setTimeout(() => this.headerVisible.set(true), 0); // Force re-render
  }

  skipToMainContent(event: Event) {
    event.preventDefault();
    const main = document.getElementById('main-content');
    if (main) {
      main.setAttribute('tabindex', '-1');
      main.focus();
    }
  }
}
